import script from "./STPage.vue?vue&type=script&setup=true&lang=js"
export * from "./STPage.vue?vue&type=script&setup=true&lang=js"

import "./STPage.vue?vue&type=style&index=0&id=340e2918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340e2918"]])

export default __exports__